import { useSEO } from '../lib/seo';
import TensionExperience from '../../components/TensionExperience';

export default function EarlyAccessLanding() {
  useSEO({
    title: 'TENSION - Early Access',
    description:
      'TENSION combines RTI scoring, daily check-ins, action cards, and real-time guidance so couples can reduce escalation and communicate clearly.',
    canonical: '/',
    ogType: 'website',
    twitterCard: 'summary_large_image',
  });

  return <TensionExperience />;
}
